var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "apply-wrapper" }, [
    _c(
      "div",
      { staticClass: "apply-card" },
      [
        !_vm.sent
          ? [
              _c("h2", { staticClass: "mb-1" }, [
                _vm._v(_vm._s(_vm.$t("influencer_apply.title"))),
              ]),
              _c("p", { staticClass: "text-muted mb-3" }, [
                _vm._v(_vm._s(_vm.$t("influencer_apply.subtitle"))),
              ]),
              _c(
                "b-form-group",
                { attrs: { label: _vm.$t("influencer.name") } },
                [
                  _c("b-form-input", {
                    attrs: { type: "text", state: _vm.fieldState("name") },
                    model: {
                      value: _vm.model.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.model, "name", $$v)
                      },
                      expression: "model.name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "b-form-group",
                { attrs: { label: _vm.$t("influencer.email") } },
                [
                  _c("b-form-input", {
                    attrs: { type: "email", state: _vm.fieldState("email") },
                    model: {
                      value: _vm.model.email,
                      callback: function ($$v) {
                        _vm.$set(_vm.model, "email", $$v)
                      },
                      expression: "model.email",
                    },
                  }),
                  _c("small", { staticClass: "text-muted" }, [
                    _vm._v(_vm._s(_vm.$t("influencer_apply.email_hint"))),
                  ]),
                ],
                1
              ),
              _c("div", { staticClass: "vx-row" }, [
                _c(
                  "div",
                  { staticClass: "vx-col sm:w-1/2 w-full" },
                  [
                    _c(
                      "b-form-group",
                      { attrs: { label: _vm.$t("influencer.person_type") } },
                      [
                        _c("b-form-radio-group", {
                          attrs: { options: _vm.personTypes },
                          model: {
                            value: _vm.model.person_type,
                            callback: function ($$v) {
                              _vm.$set(_vm.model, "person_type", $$v)
                            },
                            expression: "model.person_type",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "vx-col sm:w-1/2 w-full" },
                  [
                    _c(
                      "b-form-group",
                      { attrs: { label: _vm.$t("influencer.document") } },
                      [
                        _c("b-form-input", {
                          attrs: { type: "text" },
                          model: {
                            value: _vm.model.document,
                            callback: function ($$v) {
                              _vm.$set(_vm.model, "document", $$v)
                            },
                            expression: "model.document",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
              _c(
                "b-form-group",
                { attrs: { label: "Data de nascimento" } },
                [
                  _c("b-form-input", {
                    attrs: { type: "date" },
                    model: {
                      value: _vm.model.birthdate,
                      callback: function ($$v) {
                        _vm.$set(_vm.model, "birthdate", $$v)
                      },
                      expression: "model.birthdate",
                    },
                  }),
                  _vm.model.birthdate && !_vm.isOfAge
                    ? _c("small", { staticClass: "text-danger d-block" }, [
                        _vm._v(
                          " É necessário ter pelo menos " +
                            _vm._s(_vm.minAge) +
                            " anos. "
                        ),
                      ])
                    : _c("small", { staticClass: "text-muted" }, [
                        _vm._v(
                          " Necessária para confirmar a idade mínima de " +
                            _vm._s(_vm.minAge) +
                            " anos. "
                        ),
                      ]),
                ],
                1
              ),
              _c(
                "b-form-group",
                { attrs: { label: _vm.$t("influencer.bio") } },
                [
                  _c("b-form-textarea", {
                    attrs: {
                      rows: "2",
                      placeholder: _vm.$t("influencer_apply.bio_placeholder"),
                    },
                    model: {
                      value: _vm.model.bio,
                      callback: function ($$v) {
                        _vm.$set(_vm.model, "bio", $$v)
                      },
                      expression: "model.bio",
                    },
                  }),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "flex justify-between items-center mb-1" },
                [
                  _c("label", { staticClass: "mb-0" }, [
                    _vm._v(_vm._s(_vm.$t("influencer.networks"))),
                  ]),
                  _c(
                    "b-button",
                    {
                      attrs: { size: "sm", variant: "outline-primary" },
                      on: { click: _vm.addProfile },
                    },
                    [_c("feather-icon", { attrs: { icon: "PlusIcon" } })],
                    1
                  ),
                ],
                1
              ),
              _c("small", { staticClass: "text-muted d-block mb-2" }, [
                _vm._v(_vm._s(_vm.$t("influencer_apply.networks_hint"))),
              ]),
              _vm._l(_vm.model.social_profiles, function (profile, index) {
                return _c(
                  "div",
                  { key: index, staticClass: "vx-row items-end mb-1" },
                  [
                    _c(
                      "div",
                      { staticClass: "vx-col sm:w-4/12 w-full" },
                      [
                        _c("b-form-select", {
                          attrs: { options: _vm.networks },
                          model: {
                            value: profile.network,
                            callback: function ($$v) {
                              _vm.$set(profile, "network", $$v)
                            },
                            expression: "profile.network",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "vx-col sm:w-5/12 w-full" },
                      [
                        _c("b-form-input", {
                          attrs: { type: "text", placeholder: "@seu.perfil" },
                          model: {
                            value: profile.handle,
                            callback: function ($$v) {
                              _vm.$set(profile, "handle", $$v)
                            },
                            expression: "profile.handle",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "vx-col sm:w-2/12 w-full" },
                      [
                        _c("b-form-input", {
                          attrs: {
                            type: "number",
                            min: "0",
                            placeholder: _vm.$t("influencer.followers"),
                          },
                          model: {
                            value: profile.followers,
                            callback: function ($$v) {
                              _vm.$set(profile, "followers", $$v)
                            },
                            expression: "profile.followers",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "vx-col sm:w-1/12 w-full" },
                      [
                        _vm.model.social_profiles.length > 1
                          ? _c("feather-icon", {
                              staticClass:
                                "h-5 w-5 stroke-current text-danger cursor-pointer",
                              attrs: { icon: "Trash2Icon" },
                              on: {
                                click: function ($event) {
                                  return _vm.model.social_profiles.splice(
                                    index,
                                    1
                                  )
                                },
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]
                )
              }),
              _c(
                "b-form-checkbox",
                {
                  staticClass: "mt-3",
                  model: {
                    value: _vm.model.terms_accepted,
                    callback: function ($$v) {
                      _vm.$set(_vm.model, "terms_accepted", $$v)
                    },
                    expression: "model.terms_accepted",
                  },
                },
                [_vm._v(" " + _vm._s(_vm.$t("influencer_apply.terms")) + " ")]
              ),
              _vm.errorMessage
                ? _c(
                    "b-alert",
                    {
                      staticClass: "mt-2 p-1",
                      attrs: { variant: "danger", show: "" },
                    },
                    [_c("small", [_vm._v(_vm._s(_vm.errorMessage))])]
                  )
                : _vm._e(),
              _c(
                "b-button",
                {
                  staticClass: "mt-3 w-full",
                  attrs: {
                    variant: "primary",
                    disabled: !_vm.canSubmit || _vm.isSending,
                  },
                  on: { click: _vm.submit },
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.isSending
                          ? _vm.$t("influencer_apply.sending")
                          : _vm.$t("influencer_apply.submit")
                      ) +
                      " "
                  ),
                ]
              ),
              _c("p", { staticClass: "text-muted text-center mt-2 mb-0" }, [
                _c("small", [
                  _vm._v(_vm._s(_vm.$t("influencer_apply.review_note"))),
                ]),
              ]),
            ]
          : [
              _c(
                "div",
                { staticClass: "text-center py-4" },
                [
                  _c("feather-icon", {
                    staticClass: "h-12 w-12 text-success mb-2",
                    attrs: { icon: "CheckCircleIcon" },
                  }),
                  _c("h3", [
                    _vm._v(_vm._s(_vm.$t("influencer_apply.sent_title"))),
                  ]),
                  _c("p", { staticClass: "text-muted mb-0" }, [
                    _vm._v(_vm._s(_vm.sentMessage)),
                  ]),
                ],
                1
              ),
            ],
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }